<div id="cover-landing"
  class="text-white lg:pt-[5rem] xl:mb-[8rem] lg:mb-[2rem] mb-[1rem] xl:pt-[12rem] bg-primary lg:h-dvh h-full flex items-center relative">
  <div id="landing"
    class="container xl:mb-[22rem] lg:mt-0 mt-[5rem] lg:mb-0 md:mb-0 lg:text-start text-center xl:mt-[8rem] mx-auto px-5 lg:pb-[5rem] pb-[5rem] flex flex-row flex-wrap items-center">
    <div class="lg:w-1/2 w-full">
      <h1 class="uppercase lg:mb-4 font-bold lg:pe-5 xl:text-5xl lg:text-4xl md:text-3xl text-2xl">
        Empowering a new era of learning

      </h1>

      <p class="font-normal md:mt-5">
        Exemplix brings together smart technology and simple design to improve how students learn.
        With clear explanations, guided practice and a smooth progress tracking system, we create
        education easier for students, teachers, and parents.
      </p>
      @if (!isLoggedIn()) {
      <div class="mb-2 mt-5 flex lg:justify-start justify-center items-center">
        <a [routerLink]="hasToken ? '/home' : '/student/signup'"
          class="text-white border font-semibold border-white px-4 py-2 rounded-md transition hover:bg-white hover:text-primary">
          Get Started
        </a>
        <a class="text-white underline cursor-pointer font-semibold hover:text-white/80 ml-3"> I am a teacher </a>
      </div>
      }
    </div>

    <div class="lg:w-1/2 w-full flex justify-center items-center">
      <img width="400rem" src="Images/stars.png" alt="" />
    </div>

    <svg viewBox="0 0 1440 320"
      class="absolute xl:bottom-[-9%] lg:bottom-[-1%] bottom-[-5px] left-0 right-[-5px] w-full"
      xmlns="http://www.w3.org/2000/svg">
      <path fill="#ffffff" fill-opacity="1" d="M0,130 C360,350 800,-50 1440,120 L1440,500 L0,320 Z"></path>
    </svg>
  </div>
</div>